<template>
  <v-row no-gutters class="ma-0">
   <v-col class="text-center background mt-6 px-0 pb-4 " :class="[{'ml-n12' : !$store.state.base.isExpandNavigationDrawer}, `${$route.name !== 'AccountMembers' ? 'pagination' : 'paginationMember'}`]" :style="$store.state.base.isExpandNavigationDrawer ? `${$route.name !== 'AccountMembers' ? 'margin-left: -150px' : ''}` : ''">
    <v-btn class="subtitle-2" @click="previous" :disabled="page === 1" color="secondary" text :ripple="false">
      <v-icon class="mr-3">mdi-chevron-left</v-icon> Anterior
    </v-btn>
    <v-icon class="mx-5" color="secondary" size="8 ">mdi-circle</v-icon>
    <v-btn class="subtitle-2 font-weight-medium pa-0 btnPage" color="primary" icon small :ripple="false">{{ page }}</v-btn>
    <v-icon class="mx-5" color="secondary" size="8 ">mdi-circle</v-icon>
    <v-btn class="subtitle-2" @click="next" :disabled="!count" color="secondary" text :ripple="false">
      Siguiente <v-icon class="ml-3">mdi-chevron-right</v-icon>
    </v-btn>
  </v-col>
  <!-- <v-row class="mt-5" align="center" v-if="showPagination || showAll">
    <v-col cols="12" class="text-center" v-if="showAll">
      <v-btn :to="{name: redirect, query: showCriteria}" outlined>{{titleShowAll}}</v-btn>
    </v-col>
    <template v-if="showPagination">
      <v-col cols="5" class="py-0">
        <span class="body-1 fontBody--text">{{count}} registro{{count > 1 ? 's' : ''}}</span>
      </v-col>
      <v-col class="px-5">
        <v-row align="center" justify="end">
          <v-pagination v-model="page" :length="totalPages" total-visible="6" />
          <div class="text-right mt-n1 ml-10" v-if="totalPages > 1">
            <div class="px-0 text-right d-flex" style="width: 150px;">
              <v-row class="v-sm-text-fields" align="center" no-gutters>
                <span class="body-1 fontBody--text pr-4">Ir a</span>
                <v-col cols="9">
                  <v-text-field v-model="currentPage" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" @keydown.enter="handleGoTo" @click:append="handleGoTo" required min="1" maxlength="12" height="16" outlined flat dense hide-details append-icon="mdi-chevron-right" />
                </v-col>
              </v-row>
            </div>
          </div>
        </v-row>
      </v-col>
    </template>
  </v-row> -->
</v-row>
</template>

<script>
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  mixins: [
    ListViewMixin
  ],
  props: {
    titleShowAll: {
      type: String,
      default: 'Ver todos los documentos'
    },
    redirect: {
      type: String,
      default: null
    },
    count: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    currentPage: null
  }),
  methods: {
    // handleGoTo () {
    //   const page = parseInt(this.currentPage)
    //   if (!page || (page === 0 || (page > this.totalPages))) {
    //     this.currentPage = null
    //   } else {
    //     this.page = page
    //   }
    // }
    // setPage () {
    //   if (route.query.page === page) {
    //     return false
    //   }
    //   if (['AccountMembers'].includes(route.name) && props.keyPagination) {
    //     let query = JSON.parse(JSON.stringify(route.query))
    //     query = {...route.query, ...{page: page.value, key: props.keyPagination}}
    //     router.replace({name: route.name, query: query})
    //   } else router.replace({name: route.name, query: Object.assign({}, route.query, {page: page.value})})
    // },
    previous () {
      if (this.page > 1) this.page -= 1
    },
    next () {
      if (this.count) this.page += 1
    }
  }
}
</script>